import React, { useEffect, useState } from 'react';
import axios from '../helpers/axiosConfig';
const ListEtatMajorSuccessifs = () => {
  const [etatMajorSuccessifs, setEtatMajorSuccessifs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEtatMajorSuccessifs = async () => {
      try {
        const response = await axios.get('/etatmajorsuccessifs/api/list');
        setEtatMajorSuccessifs(response.data);
        setLoading(false);
      } catch (err) {
        setError('Erreur lors du chargement des EtatMajorSuccessifs');
        setLoading(false);
      }
    };

    fetchEtatMajorSuccessifs();
  }, []);

  if (loading) {
    return <div className="container mt-5">Chargement...</div>;
  }

  if (error) {
    return <div className="container mt-5">{error}</div>;
  }

  return (
    <div className="container mt-5">
      <h1 className="alert alert-warning">Liste des Chef d'Etat Major Successifs</h1>
      <table className="table table-triped">
        <thead className="thead-dark">
          <tr>
            <th>N°</th>
            <th>Nom et Prénom</th>
            <th>Du</th>
            <th>Au</th>
          </tr>
        </thead>
        <tbody>
          {etatMajorSuccessifs.map((etatMajor, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{etatMajor.nomprenom}</td>
              <td>{etatMajor.du}</td>
              <td>{etatMajor.au || 'à ce jour'}</td>
              {/*                             <td>
                {etatMajor.filename ? (
                    <a href={`/images/cema/${etatMajor.filename}`} target="_blank" rel="noopener noreferrer">
                        Voir le fichier
                    </a>
                ) : (
                    'Aucun fichier'
                )}
            </td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ListEtatMajorSuccessifs;
